export default {
  data() {
    return {
      status: this.value
    }
  },
  watch: {
    value(n, o) {
      this.status = n
    },
    status(n, o) {
      this.$emit('input', n)
    }
  }
}
